<template>
  <div class="support-form-container">
    <div
      style="width: 16px; height: 16px; display: flex; align-items: center; justify-content: center; position: absolute; right: 16px; opacity: .5; cursor: pointer;"
      @click="handleClosePressed()"
    >
      <img src="../../assets/images/ui/icon_close.svg" alt="" srcset="" />
    </div>
    <form @submit.prevent="handleSubmit()">
      <div class="position-relative">
        <h2 class="mb-4 mt-1" style="text-align: center;">Contact Support</h2>
      </div>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          v-model="name"
          placeholder="Name"
          required
        />
        <label><span class="support-form-required-field">*</span> Name:</label>
      </div>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          v-model="email"
          placeholder="Email"
          required
        />
        <label><span class="support-form-required-field">*</span> Email:</label>
      </div>
      <div class="form-group">
        <select
          name="office"
          id="office"
          class="form-control"
          v-model="agency"
          required
        >
          <option value="" disabled hidden>Select Office</option>
          <option
            v-for="agency in agencies"
            :key="agency.id"
            :value="agency.id"
          >
            {{ agency.displayName }}</option
          >
        </select>
        <label
          ><span class="support-form-required-field">*</span> Office:</label
        >
      </div>
      <div class="form-group">
        <select
          name="concern"
          id="concern"
          class="form-control"
          v-model="concern"
          required
        >
          <option value="" disabled hidden>Select Concern</option>
          <option
            v-for="availableConcern in concernSelection"
            :key="availableConcern"
            :value="availableConcern"
          >
            {{ availableConcern }}</option
          >
        </select>
        <label
          ><span class="support-form-required-field">*</span> What do you need
          help with?</label
        >
      </div>
      <div class="form-group">
        <textarea
          name="details"
          id="details"
          v-model="details"
          class="form-control"
          required
        ></textarea>
        <label
          ><span class="support-form-required-field">*</span> Details:</label
        >
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>
  </div>
</template>
<script>
import LookupServices from '../../services/lookups';
import SupportSubmissionServiceV2 from '../../services/V2/SupportSubmissionService';

export default {
  data() {
    return {
      name: null,
      email: null,
      agency: '',
      concern: '',
      details: null,
      agencies: [],
    };
  },
  computed: {
    concernSelection() {
      return [
        'Booking a campaign',
        'Current campaign',
        'Report a bug',
        'Other',
      ];
    },
  },
  methods: {
    handleClosePressed() {
      this.resetForm();
      this.$emit('on-close-pressed');
    },
    async getAgencies() {
      const response = await LookupServices.getAgencies();
      if (response && response.data && response.data.lookups) {
        this.agencies = response.data.lookups;
      }
    },
    resetForm() {
      this.concern = null;
      this.details = null;
      this.agency = '';
      this.concern = '';
    },
    async handleSubmit() {
      const payload = {
        name: this.name,
        email: this.email,
        concern: this.concern,
        details: this.details,
        agencyId: this.agency,
        submittedById: this.$store.getters.getUser.id,
      };
      try {
        await SupportSubmissionServiceV2.createSubmission(payload);
        this.$swal({
          type: 'success',
          title: 'Support Form Submitted!',
          text: 'Thank you for your submission to support.',
        });

        this.resetForm();
        this.$emit('on-submitted');
      } catch (error) {
        this.$swal({
          type: 'error',
          title: 'An error occured',
          text: 'Could not submit your support query at this time.',
        });
      }
    },
  },
  mounted() {
    const user = this.$store.getters.getUser;

    if (user) {
      this.name = user.firstName;
      this.email = user.username;
    }

    this.getAgencies();
  },
};
</script>
<style scoped>
.support-form-container {
  background-color: white;
  padding: 16px 16px 28px 16px;
  width: 320px;
  box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
}
.support-form-required-field {
  color: red;
}
</style>
